import { donationCardSlice } from '@/application/redux-store/donation-card/donation-card-slice';
import { migrationCardSlice } from '@/application/redux-store/migration-card/migration-card-slice';
import { themeSlice } from '@/application/redux-store/theme/theme-slice';
import { createAction, Reducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { GlobalState } from './types';

const combinedReducer: Reducer<GlobalState> = combineReducers({
  theme: themeSlice.reducer,
  donationCard: donationCardSlice.reducer,
  migrationCard: migrationCardSlice.reducer,
});

export const logoutAction = createAction('logout');

export const rootReducer: Reducer<GlobalState> = (state, action) => {
  if (action.type === logoutAction.type) {
    state = undefined;
  }

  return combinedReducer(state, action);
};
